import React from 'react';
import { connect } from 'react-redux';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend
} from 'recharts';
import { orderBy } from 'lodash';

import {
  isEqual as isEqualDate,
  getDateRange,
  toFromDate,
  toToDate
} from '~/utils/dateHelpers';
import { misspickStats } from '~/actions/boxStats';

import Styles from './widget.scss';

class BoxMissPickChart extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const dateRange = getDateRange(
      props.indata.from,
      props.indata.to,
      props.indata.period
    );

    this.state = {
      from: dateRange.from,
      to: dateRange.to,
      previousFrom: dateRange.from,
      previousTo: dateRange.to,
      misspicks: [],
      loading: true
    };
  }

  componentDidMount() {
    this.loadStats();
  }

  componentWillReceiveProps(nextProps) {
    const dateRange = getDateRange(
      nextProps.indata.from,
      nextProps.indata.to,
      nextProps.indata.period
    );
    if (
      !isEqualDate(toFromDate(this.state.previousFrom), dateRange.from) ||
      !isEqualDate(toToDate(this.state.previousTo), dateRange.to)
    ) {
      this.setState(
        {
          from: dateRange.from,
          to: dateRange.to,
          previousFrom: dateRange.from,
          previousTo: dateRange.to
        },
        this.loadStats
      );
    }
  }

  getData() {
    const { users } = this.props;
    const data = [];
    Object.values(users.toJS()).forEach(u => {
      const misspicks = this.state.misspicks.filter(m => m.userId === u.userId)
        .length;
      if (misspicks > 0) {
        data.push({
          ...u,
          misspicks
        });
      }
    });
    return orderBy(data, ['misspicks', 'name'], ['desc', 'asc']);
  }

  loadStats() {
    const { from, to } = this.state;
    this.setState({ loading: true });
    misspickStats(
      this.context.apiClient,
      toFromDate(from, true),
      toToDate(to, true)
    ).then(r =>
      this.setState({
        loading: false,
        misspicks: r.data
      })
    );
  }

  render() {
    const data = this.getData();
    return (
      <div className={`${this.props.className} ${Styles.widget}`}>
        <h5 className={Styles.title}>{this.props.indata.title}</h5>
        <div className={Styles.content}>
          {this.state.loading && 'Loading misspicks...'}
          {!this.state.loading && data.length === 0 && 'No data to show.'}
          {!this.state.loading &&
            data.length > 0 && (
              <ResponsiveContainer minHeight={200} className={Styles.chart}>
                <BarChart data={data}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis
                    label={{
                      value: 'Misspicks',
                      angle: -90,
                      position: 'insideLeft'
                    }}
                  />
                  <Tooltip />
                  <Legend />
                  <Bar
                    dataKey="misspicks"
                    fill="#ff4422"
                    name="Misspicks"
                    maxBarSize={40}
                  />
                </BarChart>
              </ResponsiveContainer>
            )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  users: state.getIn(['user', 'users'], false)
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(
  BoxMissPickChart
);



// WEBPACK FOOTER //
// ./app/widgets/BoxMissPickChart/widget.js